import React, { useEffect, ReactNode } from 'react';
import { initializeApp } from 'firebase/app';
import { endpoints } from '../config';

const firebaseConfig = {
  apiKey: endpoints.firebase_config.apiKey,
  authDomain: endpoints.firebase_config.authDomain,
  databaseURL: endpoints.firebase_config.databaseURL,
  projectId: endpoints.firebase_config.projectId,
  storageBucket: endpoints.firebase_config.storageBucket,
  messagingSenderId: endpoints.firebase_config.messagingSenderId,
  appId: endpoints.firebase_config.appId,
};

interface NotificationProviderProps {
  children: ReactNode;
}

const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  useEffect(() => {

    initializeApp(firebaseConfig);

  }, []);

  return <>{children}</>;
};

export default NotificationProvider;

